import { useMemo } from "react";

import { getPermissionModules } from "@/D2C/features/auth/utils/permissions";
import { usePosterReducers } from "@/shared/redux/store/useGetData";

import { getSecureNavItemsFromModules } from "./navigation";
import { getSecureRoutesFromModules } from "./routes";
import { SecureAccess } from "./type";

export function useSecureAccess(): SecureAccess {
  const {
    auth: { user },
  } = usePosterReducers();

  return useMemo(() => {
    const permissionModules = getPermissionModules(user?.user);
    const navItems = getSecureNavItemsFromModules(permissionModules);
    const routes = getSecureRoutesFromModules(permissionModules);
    const grantedModuleNames = new Set(permissionModules?.map((module) => module?.module_name));
    const moduleByPath = new Map(
      permissionModules
        ?.filter((module) => module?.path)
        .map((module) => [module.path as string, module])
    );

    return {
      permissionModules,
      grantedModuleNames,
      moduleByPath,
      navItems,
      routes,
      fallbackPath: navItems[0]?.path,
    };
  }, [user?.user]);
}
